<template>
  <vx-card>
    <vs-tabs class="tab-action-btn-fill-container">
      <vs-tab label="Acccount">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <div class="p-6">
            <div class="vx-col sm:w-3/6" style="padding: 10px 0;">
              <drop-zone
                :text="`Upload Avatar`"
                :accept="`image/*`"
                :displayAs="'image'"
                v-model="form.profilePicture"
              />
              <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
            </div>

            <ValidationProvider rules="required|min:5" name="name" v-slot="{ errors }" tag="div">
              <vs-input label="Name" v-model="form.name" class="mt-5 w-full" />
              <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|min:5|alpha_num" name="username" v-slot="{ errors }" tag="div">
              <vs-input label="Username" v-model="form.username" class="mt-5 w-full" />
              <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="min:5|max:12" name="password" v-slot="{ errors }" tag="div">
              <vs-input type="password" label="Password" v-model="form.password" class="mt-5 w-full" />
              <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|numeric" name="phone number" v-slot="{ errors }" tag="div">
              <vs-input label="Phone Number" v-model="form.phoneNumber" class="mt-5 w-full" />
              <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required" name="status" v-slot="{ errors }" tag="div">
              <vs-select v-model="form.generalStatus" label="Status" class="mt-5 w-full">
                <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in status" />
              </vs-select>
              <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="handleSubmit" :disabled="invalid">Submit</vs-button>
          </div>
        </ValidationObserver>
      </vs-tab>
      <vs-tab label="Transactions">
        <TopUpList />
      </vs-tab>
      <vs-tab label="Purchases">
        <PurchaseList />
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DropZone from '@/components/DropZone';
import { mapActions, mapState } from 'vuex';
import TopUpList from './components/TopUpList';
import PurchaseList from './components/PurchaseList';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DropZone,
    TopUpList,
    PurchaseList,
  },
  data() {
    return {
      form: {
        name: '',
        username: '',
        password: '',
        phoneNumber: '',
        profilePicture: '',
        generalStatus: '',
      },
    };
  },
  computed: {
    status() {
      return [
        { text: 'Active', value: 'ACTIVE' },
        { text: 'Disabled', value: 'DISABLED' },
      ];
    },
    ...mapState({
      user: ({ userManagement }) => userManagement.user,
      updateUserState: ({ userManagement }) => userManagement.apiState.updateUser,
    }),
    routeName() {
      return this.$route.name;
    },
    userId() {
      return this.$route.params.id || undefined;
    },
  },
  methods: {
    ...mapActions({
      getUser: 'userManagement/getUser',
      updateUser: 'userManagement/updateUser',
    }),
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        return this.submit();
      }

      return this.$vs.dialog({
        color: 'danger',
        title: `Validation Error!`,
        text: 'There is a error in this form',
      });
    },
    async submit() {
      return this.$vs.dialog({
        color: 'primary',
        title: `Are you sure submit?`,
        text: 'Continue submit',
        acceptText: 'Yes',
        accept: () => {
          const body = {
            name: this.form.name,
            username: this.form.username,
            phoneNumber: this.form.phoneNumber,
            profilePicture: this.form.profilePicture,
            generalStatus: this.form.generalStatus,
          };

          if (this.form.password) {
            body.password = this.form.password;
          }

          return this.updateUser({
            id: this.userId,
            body,
          });
        },
      });
    },
  },
  async mounted() {
    await this.getUser(this.userId).then(() => {
      this.form = {
        ...this.form,
        name: this.user.name,
        username: this.user.username,
        phoneNumber: this.user.phoneNumber,
        profilePicture: this.user.profilePicture,
        generalStatus: this.user.generalStatus,
      };
    });
  },
  watch: {
    'updateUserState.success'(value) {
      if (value) {
        this.$vs.notify({
          title: 'Successful update!',
          color: 'success',
          position: 'top-center',
        });
      }
    },
    'updateUserState.error'(error) {
      if (error) {
        this.$vs.notify({
          title: 'Error!',
          text: error.data.message,
          color: 'danger',
          position: 'top-center',
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
